import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

import { Header } from '@/components/header';
import { Heading } from '@/components/ui/heading';
import { ROUTES } from '@/constants/routes';
import { type ContentLibraryItem } from '@/types/contentLibraryItems';

export function ContentLibraryItemHeader({
  contentLibraryItem,
}: {
  contentLibraryItem: ContentLibraryItem;
}) {
  return (
    <>
      <Header
        title={isWeb ? undefined : contentLibraryItem.title}
        documentTitle={contentLibraryItem.title}
        backRoute={ROUTES.CONTENT_LIBRARY}
        isBackButton
        contentScrollsUnderHeader
      />
      <Heading className="text-2xl" size="2xl">
        {contentLibraryItem.title}
      </Heading>
      {contentLibraryItem.subtitle && (
        <Heading className="mt-1 font-normal text-xl" size="lg">
          {contentLibraryItem.subtitle}
        </Heading>
      )}
    </>
  );
}
